import { useState } from "react";
import { MindMapContext } from "../../../Context/contex";
import { SharePrivacy } from "../SharePrivacy/SharePrivacy";
import ShareForm, { INVITE_FORM_ID } from "../SharePrivacy/ShareForm";
import { ACCESS_ANYONE, ACCESS_RESTRICTED, ACCESS_VIEW, INVITE_VIEW } from "../shareConstants";
import { FooterButton } from "./FooterButton";
import { usePublicAccess } from "./usePublicAccess";
import classes from "./ShareModalContent.module.css";

/**
 * Share dialog body: the general-access choice, or the invite view once
 * Restricted is picked, over a footer holding whichever action closes the dialog.
 */
export const ShareModalContent = ({ onClose, privacy, setPrivacy, view, setView }) => {
  const { isExternalAllow } = MindMapContext();
  const { makePublic, removePublicAccess, isPublishing, isRemoving } = usePublicAccess(onClose);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isInviteView = view === INVITE_VIEW;

  const handleBack = () => {
    setPrivacy(ACCESS_ANYONE);
    setView(ACCESS_VIEW);
  };

  const handleSelectAccess = (key) => {
    setPrivacy(key);
    if (key === ACCESS_RESTRICTED) setView(INVITE_VIEW);
  };

  if (isInviteView) {
    return (
      <div className={classes.modalContent}>
        <section className={classes.section}>
          <ShareForm onClose={onClose} onBack={handleBack} setSubmitting={setIsSubmitting} />
        </section>
        <footer className={classes.footer}>
          <FooterButton type="submit" form={INVITE_FORM_ID} isBusy={isSubmitting}>
            Share
          </FooterButton>
        </footer>
      </div>
    );
  }

  return (
    <div className={classes.modalContent}>
      <section className={classes.section}>
        <SharePrivacy privacy={privacy} setPrivacy={handleSelectAccess} />
      </section>
      {privacy === ACCESS_ANYONE && (
        <footer className={classes.footer}>
          {isExternalAllow && (
            <FooterButton variant="danger" onClick={removePublicAccess} isBusy={isRemoving}>
              Remove external
            </FooterButton>
          )}
          <FooterButton onClick={makePublic} isBusy={isPublishing} disabled={isExternalAllow}>
            {isExternalAllow ? 'Public' : 'Make public'}
          </FooterButton>
        </footer>
      )}
    </div>
  );
};
